import React from "react";
import { Doughnut } from "react-chartjs-2";
import _ from "lodash";
import { doughnutOptions } from "./_commonSharedChartOptions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  WidgetLoading,
  WidgetNoDataToDisplay,
  WidgetServerError
} from "../../../../components/DashboardWidget/WidgetCommon";
import { exitPercentDataPreview } from "./_previewData";
import "chartjs-plugin-datalabels";

const config_default = {
  alexa: {
    name: "Alexa",
    Chart: "EXIT_PERCENT_AT_INTENT_LEVEL_ALEXA",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  },
  lex: {
    name: "Browser/Mobile",
    Chart: "EXIT_PERCENT_AT_INTENT_LEVEL_LEX",
    startDate: "05/18/2019%2012:00%20AM",
    endDate: "06/17/2019%2011:59%20PM",
    skillId: "amzn1.ask.skill.37a093eb-f18b-400a-bb88-388f1cc600d5"
  }
};

class ExitPercentAlexaContentClass extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { widgetData, draggable } = this.props;
    return (
      <div>
        <div className="widgetTitle">Exit Percent - {config_default[this.state.platform].name}</div>
        <div className="widgetTitleDescription">Exit Percent - {config_default[this.state.platform].name}</div>
        <div className="widgetBody">
          {this.props.widgetData /*&& !this.state.loading*/ ? (
            widgetData.code !== 200 || draggable ? (
              <WidgetServerError draggable={draggable} />
            ) : widgetData.chart_data.data.length === 0 || draggable ? (
              <WidgetNoDataToDisplay draggable={draggable} />
            ) : (
              <Doughnut
                id="EXIT_PERCENT"
                data={{
                  labels: this.props.widgetData.chart_data.labels,
                  datasets: [
                    {
                      data: this.props.widgetData.chart_data.data,
                      backgroundColor: this.props.widgetData.chart_data.backgroundColor
                    }
                  ]
                }}
                options={_.merge({}, doughnutOptions, {
                  legend: { position: "right" },
                  plugins: {
                    datalabels: {
                      formatter: (value, ctx) => {
                        let sum = 0;
                        let dataArr = ctx.chart.data.datasets[0].data;
                        dataArr.map(data => {
                          sum += data;
                        });
                        let percentage = value + "%";
                        return percentage;
                      }
                    }
                  },
                  tooltips: {
                    callbacks: {
                      title: (tooltipItem, data) => data["labels"][tooltipItem[0]["index"]],
                      label: (item, data) => data.datasets[item.datasetIndex].data[item.index] + "%"
                    }
                  }
                })}
              />
            )
          ) : (
            <WidgetLoading />
          )}
        </div>
      </div>
    );
  }
}

export class ExitPercentAlexaPreview extends React.Component {
  render() {
    return (
      <div>
        <div className="widgetTitle">Exit Percent</div>
        <div className="widgetBody">
          <Doughnut
            id="EXIT_PERCENT"
            data={exitPercentDataPreview}
            options={_.merge({}, doughnutOptions, {
              legend: {
                position: "right",
                labels: {
                  fontSize: 8
                }
              },
              plugins: {
                datalabels: {
                  formatter: (value, ctx) => {
                    let sum = 0;
                    let dataArr = ctx.chart.data.datasets[0].data;
                    dataArr.map(data => {
                      sum += data;
                    });
                    let percentage = value + "%";
                    return percentage;
                  },
                  font: {
                    size: 5
                  }
                }
              }
            })}
          />
        </div>
      </div>
    );
  }
}

export const ExitPercentConfig = ({ instanceId, config, onConfigChange }) => {
  const selectionChanged = e => {
    return onConfigChange(instanceId, { platform: e.target.value });
  };

  return (
    <div className="weather-example-config">
      <div className="city">Choose Platform</div>
      <select className="form-control" onChange={selectionChanged} value={_.get(config, "platform", "alexa")}>
        {_.keys(config_default).map(code => (
          <option key={code} value={code}>
            {config_default[code].name}
          </option>
        ))}
      </select>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    widgetData: state.dashboard[config_default[_.get(ownProps, "config.platform", "alexa")].Chart],
    dashboardDates: state.dashboard.widgetFromToDate,
    skill: state.skill
  };
}

export const ExitPercentAlexaContent = connect(
  mapStateToProps,
  undefined
)(ExitPercentAlexaContentClass);
